import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { RegistMailComponentView } from '../RegistMailComponentView';

/**
 * メール登録単一モード
 */
export class RegistMailMode extends WprBaseViewModeInfo<RegistMailComponentView> {
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_mailAddress: WprControlInfo = null; // コントロール情報
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('RegistMailMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('初期');
		list.push('エラー');
		list.push('活性');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('sendMail', {
			enabled: [
				{ mode:	'活性',		value: true },
				{ mode:	'other',	value: false },
			],
		});
		this.addControl('buttonName', {
			value: [
				{ mode: 'エラー', value: 'メールアドレスを登録して手続きを進める' },
				{ mode: 'other', value: '送信する' },
			],
		});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (curMode === '【初期モード】') 
			return '初期';
		else if (!(this.m_mailAddress.validError))
			return '活性';
		else
			return 'エラー';
	}
	// --------------------------------------------------------------------------
}
